export default __webpack_public_path__ + "images/cell-dgEB5.png";